import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { RouteStore } from 'bernie-core';

import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { LoyaltyMessagingModel } from 'models';

import { UitkLink, UitkLinkTypeSize } from 'uitk-react-link';

export interface LoyaltyMessagingProps {
  model?: LoyaltyMessagingModel;
  routeStore?: RouteStore;
  searchCriteria: SearchCriteriaModel;
}

const LinkTracked = ClickTracker(UitkLink);

@inject('routeStore')
@observer
export class SWPToggle extends React.Component<LoyaltyMessagingProps> {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  private handleClick() {
    const { searchCriteria, routeStore } = this.props;
    routeStore.updateSearch({ useRewards: searchCriteria.useRewards !== 'true' }, {}, true);
  }

  public render() {
    const { model } = this.props;

    if (!model || !model.swpActionMessage || !model.loyaltyPointsMessage) {
      return null;
    }

    return (
      <div className="uitk-type-200 uitk-type-bold all-b-padding-two" data-stid="swp-toggle">
        {`${model.loyaltyPointsMessage} `}
        <LinkTracked
          aria-label={model.swpActionMessage}
          onClick={this.handleClick}
          linkName="PWA.SWP.Toggle"
          rfrr={`swpToggle: ${model.swpActionMessage}`}
          inline={true}
          type={UitkLinkTypeSize.SMALL}
        >
          <button>
            <span>{model.swpActionMessage}</span>
          </button>
        </LinkTracked>
      </div>
    );
  }
}
